<!--07-31-21
<div class="header">
	<div class="header-logo">
		<div class="brand-transparent"></div>
	</div>
</div>
-->

<!-- content -->

<div class="content">
<!-- 
  <div class="page-title">
      <h1 class="page-title__title category-brand__text--knock-out">UC Davis Directory</h1>
    </div> -->
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>
<!--
<app-footer></app-footer>  -->